import React, { useState } from 'react';
import { FilterItem } from "../interfaces/types";

interface SearchFilterCategoriesProps {
    categoriesFilterLabel: string;
    categories: FilterItem[];
    updateCategories: (checkbox: HTMLInputElement, value: string) => void;
    searchCategories: string[];
}

export const SearchFilterCategories: React.FC<SearchFilterCategoriesProps> = ({ categoriesFilterLabel, categories, updateCategories, searchCategories }) => {
    const [filtersExpanded, setFiltersExpanded] = useState(true);
    return (
        categories && categories.length > 0 ? <div className="search-filters-section">
            <button type="button" aria-expanded={filtersExpanded} onClick={() => {
                setFiltersExpanded(!filtersExpanded)
            }} className="search-filters-section-button">
                {categoriesFilterLabel}
            </button>
            <div className="search-filters-section-panel" role="region" aria-hidden={!filtersExpanded}>
                <div className="search-filters-section-panel-inner">
                    <ul className="stack-sm">
                        {categories.map((filter, index) => (
                            <li key={index}>
                                <input tabIndex={filtersExpanded ? null : -1} type="checkbox"
                                    checked={searchCategories.includes(filter.value)}
                                    onChange={(e) => {
                                        updateCategories(e.target as HTMLInputElement, e.target.value);
                                    }}
                                    id={`searchFilterCheckbox_${index}`} value={filter.value} />
                                <label htmlFor={`searchFilterCheckbox_${index}`}>
                                    {filter.value}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
            : null

    )
}